export const getBlobFromBuffer = (buffer: BufferSource) =>
  new Blob([buffer], {
    type: 'application/pdf',
  });
